<template>
  <div
    :class="[
      'side',
      isShow ? 'noexpand' : 'expand',
      { 'other-page': !is_home },
    ]"
  >
    <img
      v-if="isShow"
      class="arrow"
      src="https://staticweb.ewan.cn/resources/img/ddj-tw/side_right_arrow.png"
      @click="chageShow"
    />
    <img
      v-else
      class="arrow"
      src="https://staticweb.ewan.cn/resources/img/ddj-tw/side_left_arrow.png"
      @click="chageShow"
    />
    <div class="content" @click="chageShow">
      <div class="download">
        <img
          @click="go('https://www.facebook.com/happybigboss')"
          src="https://staticweb.ewan.cn/resources/img/ddj-tw/fb_down.png"
        />
        <img @click="go('https://play.google.com/store/apps/details?id=com.lets.psan.hwft')" src="https://staticweb.ewan.cn/resources/img/ddj-tw/google_down.png" />
        <img @click="go('https://itunes.apple.com/tw/app/id1572988056')" src="https://staticweb.ewan.cn/resources/img/ddj-tw/apple_down.png" />
      </div>
      <div class="qrcode">
        <img src="https://staticweb.ewan.cn/resources/img/ddj-tw/qrcode-google.png" alt="" />
        <!-- <img
          v-if="m && android"
          src="https://staticweb.ewan.cn/resources/img/ddj-tw/qrcode-google.png"
          alt=""
        />
        <img
          v-if="m && !android"
          src="https://staticweb.ewan.cn/resources/img/ddj-tw/qrcode-ios.png"
          alt=""
        /> -->
        <img class="light-line" src="https://staticweb.ewan.cn/resources/img/ddj-tw/light-line.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShow: true,
      state: this.$store.state,
      // m: false,
      // android: true,
    };
  },
  computed: {
    cur_route() {
      return this.state.currentRoute;
    },

    // 是否在首页
    is_home() {
      return this.cur_route == "Home";
    },
  },
  methods: {
    chageShow() {
      this.isShow = !this.isShow;
    },

    go(url) {
      window.open(url);
    },
    // isPhone() {
    //   var userAgentInfo = navigator.userAgent;
    //   var Agents = new Array(
    //     "Android",
    //     "iPhone",
    //     "SymbianOS",
    //     "Windows Phone",
    //     "iPad",
    //     "iPod"
    //   );
    //   var flag = false;
    //   for (var v = 0; v < Agents.length; v++) {
    //     if (userAgentInfo.indexOf(Agents[v]) > 0) {
    //       flag = true;
    //       break;
    //     }
    //   }
    //   return flag;
    // },
    // isAndroid() {
    //   var u = navigator.userAgent;
    //   var ua = u.toLowerCase();
    //   if (/iphone|ipad|ipod/.test(ua)) {
    //     return false;
    //   } else if (/android/.test(ua)) {
    //   }
    //   return true;
    // },
  },
};
</script>
<style scoped lang="scss">
@keyframes float {
  0% {
    transform: translatey(0px);
  }
  50% {
    transform: translatey(-20px);
  }
  100% {
    transform: translatey(0px);
  }
}

@keyframes noexpand {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(70%);
  }
}
@keyframes expand {
  0% {
    transform: translateX(70%);
  }
  100% {
    transform: translateX(0);
  }
}

@media screen and (max-width: 768px) {
  .side {
    display: none;
  }
}

.side {
  position: fixed;
  width: 250px;
  height: 680px;
  top: calc(50% - 340px);
  right: 0;
  z-index: 1000;
  transform: translatey(0px);
  animation: float 3s ease-in-out infinite;
  &.other-page {
    position: absolute;
    top: 330px;
  }
  &.noexpand {
    //收起
    animation: expand 0.5s ease-in 1;
    animation-fill-mode: forwards;
  }
  &.expand {
    //展开
    animation: noexpand 0.5s ease-in 1;
    animation-fill-mode: forwards;
  }
  > .arrow {
    cursor: pointer;
    position: absolute;
    top: 210px;
    right: 30px;
    width: 181px;
    height: 54px;
  }
  > .content {
    width: 250px;
    height: 649px;
    background-image: url(https://staticweb.ewan.cn/resources/img/ddj-tw/side_full.png);
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    > .download {
      display: flex;
      flex-direction: column;
      position: absolute;
      right: 12px;
      bottom: 268px;
      > img {
        width: 144px;
        height: 44px;
        opacity: 0.9;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
        &:hover {
          opacity: 1;
        }
      }
    }
    > .qrcode {
      position: absolute;
      bottom: 110px;
      right: 12px;
      width: 143px;
      height: 143px;
      > img {
        width: 143px;
        height: 143px;
      }
      > .light-line {
        position: absolute;
        top: 50%;
        left: 0;
        width: 144px;
        height: 10px;
        transform: translatey(0px);
        animation: floatLine 3s ease-in-out infinite;
      }
    }
  }
}
</style>